import {is_Empty} from "../utils/utils";

export default {
    SET: (state, obj) => {
        state[obj.key] = obj.value;
    },
    setSwitchCompany(state, v) {
        state.switchCompany = v
    },
    setInsertOrder(state, v) {
        state.insertOrder = v;
    },
    editInstance(state, v) {
        state.instance = v
    },
    setSaleInfo(state, v) {
        state.sale_info = v;
    },
    setSalePermission_ids(state, v) {
        state.sale_permission_ids = v;
    },
    setCompanyId(state, v) {
        state.company_id = v
    },
    setCompanyInfo(state, v) {
        state.company_info = v;
    },
    //代客下单时，当前客户ID。
    setCurrentCompanyId(state, v) {
        state.current_company_id = v;
    },
    setMemberInfo(state, value) {
        if (!is_Empty(value)) {
            value.member_type = value.member_type.map(Number)
            value.role_ids = value.role_ids.map(Number)
            state.is_company = value.member_type.indexOf(2) !== -1;
            state.is_sales = value.member_type.indexOf(4) !== -1 && value.role_ids.indexOf(8) !== -1;
            state.is_platform_technician = value.role_ids.indexOf(15) !== -1
            state.is_part_time_sale = value.role_ids.indexOf(13) !== -1;
            state.is_technician = value.role_ids.indexOf(7) !== -1;
            state.is_login = true;
        } else {
            state.is_login = false;
            state.is_sales = false;
            state.is_platform_technician = false;
            state.is_technician = false;
            state.is_company = false;
            state.is_part_time_sale = false;
        }
        state.memberInfo = value;
    },
    setUserPermission(state, v) {
        state.permission_ids = v;
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js